module.exports = __webpack_public_path__ + "static/media/1.db46b9dd.png";